import { useCurrentUser } from '../../../../../modules/context/UserContext'
import { s_menu, s_pricing, s_signin } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'

const HeaderAuthButton = ({
  isSignUpPage,
  isSignInPage,
  isWelcomePage,
  data,
  isTrialCompletePage,
  key = '',
  handleOnClickPurchase,
  handleOnClickAuthBtn,
  handleOnClickSignUpBtn,
}) => {
  const { t } = useTranslation()
  const { currentUser } = useCurrentUser()
  return (
    <div key={key}>
      {(isSignUpPage || !isSignInPage) &&
        ((isWelcomePage && data?.applying_trial_lesson_possible) || isTrialCompletePage ? (
          <button
            className="rounded-[5px] bg-purple-500 py-8 px-16 text-[14px] font-medium leading-[160%] text-white"
            onClick={() => handleOnClickPurchase(currentUser)}
          >
            {t(s_pricing.buy_credit)}
          </button>
        ) : (
          <button
            className="rounded-[5px] bg-purple-500 py-8 px-16 text-[14px] font-medium leading-[160%] text-white"
            onClick={() => handleOnClickAuthBtn(currentUser)}
          >
            {currentUser ? t(['로그아웃', 'Logout']) : isSignUpPage ? t(s_menu.landing.signin) : t(s_signin.sign_up)}
          </button>
        ))}
      {isSignInPage && (
        <button
          className="text-14 rounded-[5px] bg-purple-500 py-8 px-16 font-medium leading-[160%] text-white"
          onClick={() => handleOnClickSignUpBtn()}
        >
          {t(s_signin.sign_up)}
        </button>
      )}
    </div>
  )
}

export default HeaderAuthButton
